import type { HTMLAttributes, ReactNode } from "react";
import { Input } from "antd";

export interface TextFieldProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  inputMode?: HTMLAttributes<HTMLInputElement>["inputMode"];
  type?: string;
  error?: string | null;
  suffix?: ReactNode;
  wide?: boolean;
}

export default function TextField({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  inputMode,
  type,
  error,
  suffix,
  wide = false,
}: TextFieldProps) {
  return (
    <label className={`sendin-text-field ${wide ? "sendin-field-wide" : ""}`}>
      {label ? <span className="sendin-field-label">{label}</span> : null}
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        inputMode={inputMode}
        type={type}
        status={error ? "error" : undefined}
        suffix={suffix}
      />
      {error ? <em>{error}</em> : null}
    </label>
  );
}
